import { InjectionKey } from 'vue'

export const optionsInjectionKey = Symbol(
  'Command options inject key',
) as InjectionKey<{
  shouldFilter: boolean
  storeId: string
}>

export const groupOptionsInjectionKey = Symbol(
  'Command group options inject key',
) as InjectionKey<{
  groupId: string
  excludeFromFilter: boolean
}>
